import { pluginId } from '../pluginId';

export const getTrad = (id) => `${pluginId}.${id}`;
